/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as operations from "./operations";
import { QnAMakerRuntimeClientContext } from "./qnAMakerRuntimeClientContext";

class QnAMakerRuntimeClient extends QnAMakerRuntimeClientContext {
  // Operation groups
  runtime: operations.Runtime;

  /**
   * Initializes a new instance of the QnAMakerRuntimeClient class.
   * @param runtimeEndpoint QnA Maker App Service endpoint (for example:
   * https://{qnaservice-hostname}.azurewebsites.net).
   * @param credentials Subscription credentials which uniquely identify client subscription.
   * @param [options] The parameter options
   */
  constructor(credentials: msRest.ServiceClientCredentials, runtimeEndpoint: string, options?: msRest.ServiceClientOptions) {
    super(credentials, runtimeEndpoint, options);
    this.runtime = new operations.Runtime(this);
  }
}

// Operation Specifications

export {
  QnAMakerRuntimeClient,
  QnAMakerRuntimeClientContext,
  Models as QnAMakerRuntimeModels,
  Mappers as QnAMakerRuntimeMappers
};
export * from "./operations";
